import { render, staticRenderFns } from "./ModifyConfirmOrderForm.vue?vue&type=template&id=1367893a&scoped=true&"
import script from "./ModifyConfirmOrderForm.vue?vue&type=script&lang=js&"
export * from "./ModifyConfirmOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./ModifyConfirmOrderForm.vue?vue&type=style&index=0&id=1367893a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367893a",
  null
  
)

export default component.exports